export default __webpack_public_path__ + "static/media/gallery4.503c9c3e.png";